namespace GeniuzPOS.QRreport {
    export class QRywcSpecColumns {
        static columnsKey = 'QRreport.QRywcSpec';
    }
}
